"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMenu = void 0;
exports.defaultMenu = {
    VIDEO_YOUTUBE: [
        'COPY',
        'CUT',
        'PASTE',
        'DUPLICATE',
        'DELETE',
        'LAYER_ORDER',
        'LOCK',
        'VIDEO_SETTINGS',
        'VIDEO_REPOSITION',
        'ANIMATE',
        'POSITION',
        'LIBRARY_ADD',
        'LIBRARY_ADD_QUIET',
        'GROUP_GROUP',
        'RESTRICT_CHANGES',
        'VIDEO_AUTOPLAY',
        'VIDEO_MUTE',
        'VIDEO_LOOP',
        'VIDEO_FULLSCREEN',
        'VIDEO_CONTROLS',
        'VIDEO_MOVE_TO_NEXT',
        'TRANSFORM',
        'ROTATE',
        'DUPLICATE',
        'OPACITY',
        'ORDER',
        'ARRANGE',
        'ALIGNMENT',
        'LOCK',
        'UNLOCK',
        'REMOVE',
    ],
    VIDEO: [
        'COPY',
        'CUT',
        'PASTE',
        'DUPLICATE',
        'DELETE',
        'LAYER_ORDER',
        'LINK',
        'LOCK',
        'RESTRICT_CHANGES',
        'ANIMATE',
        'VIDEO_REPOSITION',
        'POSITION',
        'TRANSFORM',
        'ROTATE',
        'OPACITY',
        'LINK',
        'DUPLICATE',
        'ORDER',
        'ARRANGE',
        'ALIGNMENT',
        'LOCK',
        'UNLOCK',
        'REMOVE',
    ],
    TEXT: [
        'COPY',
        'CUT',
        'PASTE',
        'DUPLICATE',
        'DELETE',
        'LAYER_ORDER',
        'LOCK',
        'RESTRICT_CHANGES',
        'ANIMATE',
        'LIBRARY_ADD',
        'LIBRARY_ADD_QUIET',
        'TEXT_FONTFAMILY',
        'TEXT_FONTSIZE',
        'TEXT_FILL_COLOR',
        'TEXT_HEADING',
        'TEXT_BOLD',
        'TEXT_ITALIC',
        'TEXT_UNDERLINE',
        'HIGHLIGHT_COLOR',
        'TEXT_LIST',
        'TEXT_BULLETS',
        'TEXT_ALIGN',
        'TEXT_COLUMNS',
        'TEXT_SPACING',
        'EFFECTS',
        'TEXT_TYPING',
        'TEXT_CASE',
        'TEXT_AUTO_ADJUSTABLE',
        'GROUP_GROUP',
        'TRANSFORM',
        'TEXT_LINK',
        'DUPLICATE',
        'ORDER',
        'ARRANGE',
        'ALIGNMENT',
        'LOCK',
        'UNLOCK',
        'REMOVE',
        'DETACH_SMART_ASSET',
        'POSITION',
    ],
    LAYOUT: ['LAYOUT_CONFIRM', 'LAYOUT_CLOSE'],
    IMAGE: [
        'COPY',
        'CUT',
        'PASTE',
        'DUPLICATE',
        'DELETE',
        'LAYER_ORDER',
        'LINK',
        'LOCK',
        'IMAGE_BG_REMOVAL',
        'RESTRICT_CHANGES',
        'ANIMATE',
        'IMAGE_TAB',
        'IMAGE_CROP',
        'GROUP_GROUP',
        'LIBRARY_ADD',
        'IMAGE_FILTER',
        'POSITION',
        'IMAGE_REPOSITION',
        'TRANSFORM',
        'ROTATE',
        'UNLINK',
        'DUPLICATE',
        'OPACITY',
        'ORDER',
        'ARRANGE',
        'LOCK',
        'UNLOCK',
        'POSITION',
        'REMOVE',
        'FLIP_IMAGE',
        'LIBRARY_ADD_QUIET',
        'DETACH_SMART_ASSET',
        'LINK',
        'POSITION',
    ],
    STICKER: [
        'COPY',
        'CUT',
        'PASTE',
        'DUPLICATE',
        'DELETE',
        'LAYER_ORDER',
        'LINK',
        'LOCK',
        'RESTRICT_CHANGES',
        'ANIMATE',
        'FILL_COLOR',
        'STROKE_COLOR',
        'STROKE',
        'EXPLODE_STICKER',
        'GROUP_GROUP',
        'TRANSFORM',
        'ROTATE',
        'FLIP',
        'LINK',
        'UNLINK',
        'IMAGE_REPOSITION',
        'DUPLICATE',
        'OPACITY',
        'ORDER',
        'ARRANGE',
        'ALIGNMENT',
        'LOCK',
        'UNLOCK',
        'REMOVE',
        'LIBRARY_ADD',
        'LIBRARY_ADD_QUIET',
        'DETACH_SMART_ASSET',
    ],
    LOGO: [
        'COPY',
        'CUT',
        'PASTE',
        'DUPLICATE',
        'DELETE',
        'LAYER_ORDER',
        'LINK',
        'LOCK',
        'RESTRICT_CHANGES',
        'ANIMATE',
        'OPACITY',
        'POSITION',
        'ROTATE',
        'GROUP_GROUP',
        'LIBRARY_ADD',
        'LIBRARY_ADD_QUIET',
        'DETACH_SMART_ASSET',
        'TRANSFORM',
        'LINK',
        'UNLINK',
        'DUPLICATE',
        'ORDER',
        'ARRANGE',
        'ALIGNMENT',
        'LOCK',
        'UNLOCK',
        'REMOVE',
    ],
    ICON: [
        'COPY',
        'CUT',
        'PASTE',
        'DUPLICATE',
        'DELETE',
        'LAYER_ORDER',
        'LINK',
        'LOCK',
        'ANIMATE',
        'IMAGE_BOX',
        'POSITION',
        'FILL_COLOR',
        'STROKE_COLOR',
        'STROKE',
        'GROUP_GROUP',
        'RESTRICT_CHANGES',
        'LIBRARY_ADD',
        'LIBRARY_ADD_QUIET',
        'DETACH_SMART_ASSET',
        'TRANSFORM',
        'ROTATE',
        'UNLINK',
        'OPACITY',
        'ORDER',
        'ARRANGE',
        'ALIGNMENT',
        'UNLOCK',
        'REMOVE',
    ],
    GROUP: [
        'RESTRICT_CHANGES',
        'ANIMATE',
        'GROUP_GROUP',
        'GROUP_UNGROUP',
        'LIBRARY_ADD',
        'LIBRARY_ADD_QUIET',
        'ARRANGE',
        'ALIGNMENT',
        'TRANSFORM',
        'ROTATE',
        'LINK',
        'UNLINK',
        'DUPLICATE',
        'OPACITY',
        'LOCK',
        'UNLOCK',
        'TRANSFORM',
        'FLIP',
        'ORDER',
        'REMOVE',
    ],
    DEFAULT: [
        'RESTRICT_CHANGES',
        'ANIMATE',
        'IMAGE_BOX',
        'GROUP_GROUP',
        'LIBRARY_ADD',
        'LIBRARY_ADD_QUIET',
        'BACKGROUND_COLOR_IMAGE',
        'FILL_COLOR',
        'STROKE_COLOR',
        'STROKE',
        'TRANSFORM',
        'ROTATE',
        'FLIP',
        'LINK',
        'UNLINK',
        'DUPLICATE',
        'OPACITY',
        'ORDER',
        'ARRANGE',
        'ALIGNMENT',
        'LOCK',
        'UNLOCK',
        'REMOVE',
        'DETACH_SMART_ASSET',
    ],
    BACKGROUND: [
        'RESTRICT_CHANGES',
        'ANIMATE',
        'IMAGE_BOX',
        'IMAGE_BG_REMOVAL',
        'IMAGE_REPOSITION',
        'FILL_COLOR',
    ],
    TABLE_EDIT: [
        'RESTRICT_CHANGES',
        'CELL_EDIT_BORDER',
        'TABLE_ROWS_AND_COLUMNS',
        'CELL_FONT_FAMILY',
        'CELL_FONT_SIZE',
        'CELL_COLOR',
        'CELL_BOLD',
        'CELL_ITALIC',
        'CELL_UNDERLINE',
        'CELL_HIGHLIGHT',
        'CELL_LIST',
        'CELL_BULLETS',
        'CELL_EDIT_ALIGNMENT',
        'CELL_BACKGROUND',
        'CELL_SPACING',
        'CELL_TEXT_TYPING',
        'CELL_TEXT_ALIGNMENT',
        'CELL_CASE',
        'CELL_MERGE',
        'CELL_SPLIT',
        'LINK',
        'DUPLICATE',
        'OPACITY',
        'ORDER',
        'ALIGNMENT',
        'LOCK',
        'UNLOCK',
        'REMOVE',
    ],
    TABLE: [
        'CELL_EDIT_BORDER',
        'TABLE_ROWS_AND_COLUMNS',
        'CELL_FONT_FAMILY',
        'CELL_FONT_SIZE',
        'CELL_COLOR',
        'CELL_BOLD',
        'CELL_ITALIC',
        'CELL_TEXT_ALIGNMENT',
        'ALIGNMENT',
        'RESTRICT_CHANGES',
        'ORDER',
        'CELL_BULLETS',
        'CELL_LIST',
        'CELL_LINK',
        'TEXT_COLUMNS',
        'TEXT_SPACING',
        'EFFECTS',
        'POSITION',
        'DUPLICATE',
        'ORDER',
        'ALIGNMENT',
        'LOCK',
        'UNLOCK',
        'REMOVE',
    ],
    ROOT: [
        'ROOT_DRAWING',
        'ROOT_SHAPES',
        'ROOT_FRAMES',
        'ROOT_TEXT',
        'ROOT_TABLE',
        'PASTE',
    ],
    BLEED: ['BLEED_SIZE', 'BLEED_CLOSE'],
    HEADER_AND_FOOTER: [
        'HEADER_AND_FOOTER_PAGE_SETTINGS',
        'HEADER_AND_FOOTER_CLOSE',
    ],
};
//# sourceMappingURL=default-menu.js.map